<template>
  <form @submit.prevent="postForm" class="newsletter__form">
    <slot></slot>
  </form>
</template>

<script>
import ApiClient from '../apiClient.js'
import EventDispatcher from '../eventDispatcher.js'

const serializeFormData = (formItem, data = {}) => {

  if ('getFormData' in formItem) {
    Object.assign(data, formItem.getFormData())
  }

  formItem.$children.forEach(function (item) {
    serializeFormData(item, data)
  })

  return data
}

export default {
  name: 'RegistrationForm',
  methods: {
    postForm(event) {
      const form = event.target

      // Browsers like Safari doesn't trigger form validation when submit action is hijacked.
      // checkValidity triggers html5 form validation in browsers that support it.
      if ('checkValidity' in form && !form.checkValidity()) {
        return false
      }

      this.$dispatch('router-load')

      const data = serializeFormData(this)

      // NOTE: Arrow function callbacks to eliminate block scoping (so we have access to 'this')
      ApiClient
        .registrationPost(data)
        .then((res) => {
          // Dispatch global event to whoever would listen
          EventDispatcher.dispatch('FormSuccess')

          // Dispatch local event (via Vue) upwards to root component
          this.$dispatch('router-success')

          // Execute onSucceed callback function if exists
          if (typeof(this.$root.config.callback.onSuccess) === 'function') {
            this.$root.config.callback.onSuccess(data)
          }
        })
        .catch((err) => {
          // Dispatch global event to whoever would listen
          EventDispatcher.dispatch('FormError')

          // Dispatch local event (via Vue) upwards to root component
          this.$dispatch('router-error')
        })
    }
  }
}

</script>


// WEBPACK FOOTER //
// RegistrationForm.vue?01d93f48